import React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  useTheme
} from '@mui/material';
import {Clear, WarningAmber} from '@mui/icons-material';
import {useTranslation} from 'react-i18next';
import ComponentLoader from '@components/loaders/component-loader/ComponentLoader';
import ModalDialog from '../base-dialog/ModalDialog';
import {DialogWrapperDiv, TextContent} from './ActionDialogStyles';
import {APP} from 'src/styles/variables';
import {LoadingButton} from '@mui/lab';

interface ModalDialogProps {
  title: string;
  description: any;
  handleCloseBtnClick: () => void;
  handleAgreeBtnClick: () => void;
  open: any;
  onClose: any;
  loader: boolean;
  yesLabelText?: string;
  noLabelText?: string;
  yesButtonColor: string;
  noButtonColor: string;
  flowSheetScreen?: any;
  AutoLogoutScreen?: boolean;
  reportsLoader?: any;
  isVitalDataGrid?: boolean;
  remainingSec?: any;
  isUnAuthenticatedPopup?: boolean;
}

const ActionModalDialog = (props: ModalDialogProps): React.ReactElement => {
  const {t} = useTranslation();
  const theme = useTheme();
  const {
    title = '',
    description,
    handleCloseBtnClick,
    handleAgreeBtnClick,
    open,
    onClose,
    loader,
    yesLabelText,
    noLabelText,
    // yesButtonColor,
    // noButtonColor,
    reportsLoader,
    flowSheetScreen = false,
    AutoLogoutScreen = false,
    isVitalDataGrid = false,
    remainingSec,
    isUnAuthenticatedPopup = false
  } = props;

  const renderTitleSection = () => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: flowSheetScreen ? 'center' : 'space-between',
          width: '100%',
          backgroundColor: flowSheetScreen
            ? `${APP.PALETTE.DATA_GRID.HEADER}`
            : '',
          borderBottom: flowSheetScreen
            ? `1px solid ${APP.PALETTE.DATA_GRID.BOTTOM_BORDER}`
            : ''
        }}>
        <DialogTitle
          sx={{
            paddingLeft: '0.4rem',
            paddingBottom: isUnAuthenticatedPopup ? '0.1rem' : '0.5rem',
            paddingTop: isUnAuthenticatedPopup ? '0.5rem' : '1rem',
            fontWeight: '600',
            color: '#000000',
            letterSpacing: '0.5px'
          }}>
          {title}
        </DialogTitle>

        {flowSheetScreen ||
        AutoLogoutScreen ||
        isUnAuthenticatedPopup ? null : (
          <Clear
            sx={{
              color: 'gray',
              cursor: 'pointer'
            }}
            onClick={handleCloseBtnClick}
          />
        )}
      </div>
    );
  };

  const renderContent = () => {
    return (
      <DialogContent
        sx={{
          padding: flowSheetScreen
            ? '0rem'
            : isUnAuthenticatedPopup
            ? '0.5rem'
            : '1rem'
        }}>
        <DialogContentText
          sx={{
            flex: '1'
          }}>
          {description}
        </DialogContentText>
      </DialogContent>
    );
  };

  const renderAutoLogoutContent = () => {
    return (
      <DialogContent
        sx={{
          padding: '1rem',
          margin: '1.5rem',
          background: APP.PALETTE.BACKGROUND.AUTO_LOGOUT,
          borderRadius: '0.25rem'
        }}>
        <Grid container spacing={2}>
          <Grid item xs={1}>
            <WarningAmber color="error" />
          </Grid>

          <Grid item xs={11}>
            <TextContent>
              {t('PRIVATE.AUTO_LOGOUT.TITLE', {ns: 'private'})}
            </TextContent>
            <TextContent style={{marginTop: '0.5rem'}}>
              You will be Logged out in{' '}
              <span
                style={{
                  color: APP.PALETTE.ROLES.RED,
                  fontWeight: 'bold',
                  fontSize: '1.2rem'
                }}>
                {remainingSec}
              </span>{' '}
              seconds. Press stay logged in to continue the session
            </TextContent>
          </Grid>
        </Grid>
      </DialogContent>
    );
  };

  const renderActionButtons = () => {
    return (
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: AutoLogoutScreen ? 'flex-start' : 'flex-end',
          width: '100%',
          padding: AutoLogoutScreen ? '1.25rem' : '8px'
        }}>
        {noLabelText ? (
          <LoadingButton
            type="submit"
            variant="outlined"
            sx={{
              fontWeight: 'normal',
              // color:
              //   flowSheetScreen || AutoLogoutScreen
              //     ? 'white'
              //     : `${noButtonColor}`,
              marginLeft: flowSheetScreen ? '0.6rem' : '1rem',
              backgroundColor: theme.palette.primary.light
              // border: '1px solid ',
              // backgroundColor: flowSheetScreen
              //   ? APP.PALETTE.SUB_MODULE_COLOR.BUTTON
              //   : AutoLogoutScreen
              //   ? noButtonColor
              //   : 'white',
              // borderColor: `${noButtonColor}`,
              // '&:hover': {
              //   border: '1px solid',
              //   borderColor: flowSheetScreen ? '' : `${noButtonColor}`,
              //   backgroundColor: flowSheetScreen
              //     ? APP.PALETTE.SUB_MODULE_COLOR.HOVER_BUTTON
              //     : ''
              // }
            }}
            onClick={handleCloseBtnClick}
            disabled={loader}>
            {noLabelText}
          </LoadingButton>
        ) : null}

        {yesLabelText ? (
          <LoadingButton
            type="submit"
            loading={loader}
            sx={{
              fontWeight: '500',
              backgroundColor: theme.palette.primary.dark,
              // backgroundColor: `${yesButtonColor}`,
              // '&:hover': {
              //   backgroundColor: `${yesButtonColor}`
              // },
              position: AutoLogoutScreen ? 'absolute' : 'relative',
              right: AutoLogoutScreen ? '2rem' : '0'
            }}
            variant="contained"
            onClick={handleAgreeBtnClick}
            autoFocus
            disabled={loader}>
            {yesLabelText}
          </LoadingButton>
        ) : null}
      </DialogActions>
    );
  };

  return (
    <ModalDialog
      onClose={onClose}
      open={open}
      flowSheetScreen={flowSheetScreen}
      isVitalDataGrid={isVitalDataGrid}>
      {reportsLoader ? (
        <ComponentLoader
          loaderSize={15}
          //  flowSheetScreen={flowSheetScreen}
        />
      ) : (
        <DialogWrapperDiv>
          {title && renderTitleSection()}
          {AutoLogoutScreen ? renderAutoLogoutContent() : renderContent()}
          {renderActionButtons()}
        </DialogWrapperDiv>
      )}
    </ModalDialog>
  );
};
export default ActionModalDialog;
